import React from 'react';
import Adds from './add';

class Title extends React.Component {

  state = {

  }

  render() {
    let i = 0;
    return (
      <div>
        <table id="table" width="100%">
          <tr>
            <td id="tableheader"><center>Sino</center></td>
            <td id="tableheader"><center>Id</center></td>
            <td id="tableheader"><center>Machine</center></td>
            <td id="tableheader"><center>GST</center></td>
            <td id="tableheader"><center>MRP</center></td>
            { this.props.menuPermission.edit ?
              (
                <td id="tableheader"><center>Edit</center></td>
              ):
              ''
            }
            
          </tr>
          { this.props.data.map((x) => {
              i++;
              return (
                <tr>
                  <td><center>{i}</center></td>
                  <td><center>{x.id}</center></td>
                  <td><center>{x.name}</center></td>
                  <td><center>{x.gst}</center></td>
                  <td><center>{'Rs.'+x.mrp}</center></td>
                  { this.props.menuPermission.edit ?
                  (
                    <td style={{cursor: 'pointer', display: this.props.machineinfoedit}}>
                      <center>
                        <Adds machineinfoedit={this.props.machineinfoedit}
                              getMachine={this.props.getMachine} type='edit'
                              data={this.props.data} id={x.id} />
                      </center>
                    </td>
                  ):''
                  }
                </tr>
              )
            })
          }
        </table>
      </div>
    );
  }
}

export default Title;
